@use '@/styles/tokens' as *;

/* Figma 587:524140 — a dark translucent pill. `rgba(5,5,5,0.5)` in the frame is unbound; the app's
 * one dark map-chrome tone is `--overlay-60`, which `map-control-stack.module.scss` `.control`
 * already uses. One tone for every dark control on the map beats a second overlay step.
 *
 * `1657:789747` (Placement mode) is the same pill, value for value — which is why this rule left
 * `mapping-toolbar.module.scss` rather than being copied into a second file. */
.undo {
  display: flex;
  align-items: center;
  /* Figma 4px between glyph and label. */
  gap: var(--space-1);
  /* Figma py-5 / px-8. No --space-* token sits at 5. */
  padding: 5px var(--space-2);
  border: none;
  border-radius: $radius-pill;
  background: var(--overlay-60);
  font-size: $font-size-11;
  font-weight: $font-weight-regular;
  color: $color-white-100;
  cursor: pointer;

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }

  /* No Figma frame covers the no-history state (grilling Q11). Muted + not-allowed is the shipped
   * map-chrome disabled idiom — see `map-control-stack.module.scss` `.control:disabled`. */
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}
